<template>
  <div class="ms-container full-width">
    <contragent-editor />
  </div>
</template>

<script>
import ContragentEditor from '@/components/contract-editor/contragent-editor'

export default {
  components: {
    ContragentEditor
  }
}
</script>

<style>
</style>
